import { getInsFromPatient, remoteFormats } from "./index";

export const extractGetDocumentsStatusParams = (data) => {
  const { ins } = getInsFromPatient(data, remoteFormats.XML);
  
  const { uniqueIds: { uniqueId } = {}, addAccessAuthorization: { value: addAccessAuthorization} = {} } = data;
  let uniqueIds = uniqueId;
  if (uniqueId && !Array.isArray(uniqueId)) {
    uniqueIds = [uniqueId];
  }
  
  return {
    ins,
    uniqueIds: uniqueIds.map(id => id.value),
    addAccessAuthorization: [true, "true", "1", 1].includes(addAccessAuthorization),
  }
}

export const extractJSONGetDocumentsStatusParams = (data) => {
  const { ins } = getInsFromPatient(data, remoteFormats.JSON);
  
  const { uniqueIds, addAccessAuthorization } = data;
  
  return {
    ins,
    uniqueIds,
    addAccessAuthorization
  }
}